import { createSlice } from '@reduxjs/toolkit';
import { t_cpap_instructions } from 'types';
import { getCPAPDetail } from './thunk';

type InitialState = {
  loading: boolean;
  cpap_detail: t_cpap_instructions;
};

const initialState: InitialState = {
  loading: false,
  cpap_detail: {},
};

const updateCpapInstructionsSlices = createSlice({
  name: 'updateCpapInstructions',
  initialState,
  reducers: {
    updateItem: (state, action) => {
      return { ...state, cpap_detail: action.payload };
    },
    resetItemUpdate: (state) => {
      return {
        ...state,
        cpap_detail: {},
        medical_detail: {},
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCPAPDetail.pending, (state) => ({ ...state, loading: true }));
    builder.addCase(getCPAPDetail.fulfilled, (state, action) => ({
      ...state,
      loading: false,
      cpap_detail: action.payload,
    }));
    builder.addCase(getCPAPDetail.rejected, (state) => ({ ...state, loading: false }));
  },
});

export const { updateItem, resetItemUpdate } = updateCpapInstructionsSlices.actions;

export default updateCpapInstructionsSlices.reducer;
